import { CSSProperties, useMemo } from "react";

import "./Section.scss";

export type TSize = "xl" | "lg" | "md" | "sm";

interface Props {
  children: JSX.Element | Array<JSX.Element>;
  size?: TSize;
  className?: string;
  style?: CSSProperties;
  id?: string;
}

export const Section = ({
  children,
  size = "lg",
  className = "",
  style = {},
  id,
}: Props) => {
  const maxWidthClass = useMemo(() => {
    if (size === "sm") {
      return `max-w-screen-sm`;
    } else if (size === "md") {
      return `max-w-screen-md`;
    } else if (size === "lg") {
      return `max-w-screen-lg`;
    }
    if (size === "xl") {
      return `max-w-screen-xl`;
    }
    return `max-w-screen-lg`;
  }, [size]);
  return (
    <div
      id={id}
      style={style}
      className={`px-3 py-28 sm:px-6 sm:py-36 md:px-10 md:py-40 flex justify-center ${className}`}
    >
      <div className={`${maxWidthClass} w-full`}>{children}</div>
    </div>
  );
};
